import { render, staticRenderFns } from "./PerfilView.vue?vue&type=template&id=0068cd8a"
import script from "./PerfilView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports